<template>
  <v-select
    v-model="currentCategory"
    class="select-box"
    :class="{ 'select-box--disabled': !!selectedCategory }"
    item-text="name"
    return-object
    hide-details
    :disabled="!!selectedCategory"
    :items="categories"
    :label="
      !selectedCategory
        ? $t('message.facilityDetails.services.selectServiceCategory')
        : undefined
    "
    :loading="isLoading"
    @change="$emit('change', $event)"
  />
</template>

<script>
export default {
  name: "GmbServicesCategorySelectBox",
  props: {
    categories: {
      type: Array,
      required: true
    },
    selectedCategory: {
      type: Object
    }
  },
  data() {
    return {
      isLoading: false,
      currentCategory: null
    };
  },
  watch: {
    categories: {
      handler() {
        this.currentCategory = this.selectedCategory
          ? this.categories.find(
              category => category.id === this.selectedCategory.id
            )
          : this.categories[0];
      },
      immediate: true
    }
  }
};
</script>

<style lang="scss" scoped>
.select-box {
  width: 75%;
  ::v-deep {
    .v-select__selection {
      @include font-size(14px);
    }
  }

  &--disabled {
    margin: 0;
    padding: 0;
  }
}
::v-deep.v-select-list {
  div.v-list-item__title {
    @include font-size(14px);
  }
}
</style>
